// extracted by mini-css-extract-plugin
module.exports = {"CollapseContent-content":"CollapseContent-content--2u7Ev","CollapseContent-btn":"CollapseContent-btn--UwNay"};